export default __webpack_public_path__ + "static/media/invite-dependant-icon.4e8e457b.svg";